"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFilter = void 0;
var tslib_1 = require("tslib");
var AdvancedFilter_1 = require("./AdvancedFilter");
var NumberFilter = /** @class */ (function (_super) {
    tslib_1.__extends(NumberFilter, _super);
    function NumberFilter(fields) {
        var _this = _super.call(this) || this;
        if (typeof fields === 'object') {
            Object.assign(_this, fields);
        }
        return _this;
    }
    return NumberFilter;
}(AdvancedFilter_1.AdvancedFilter));
exports.NumberFilter = NumberFilter;
//# sourceMappingURL=NumberFilter.js.map